export const RNWelcome = '/welcome'
export const RNCarrierGroups = '/carrier-groups'
export const RNCarriers = '/carriers'
export const RNSensors = '/sensors'
export const RNLogging = '/logging'
export const RNLoggingCodes = '/1ogging-codes'
export const RNUsers = '/users'
export const RNBalance = '/balance'
export const RNProfile = '/profile'
export const RNLogin = '/login'
export const RNRegister = '/register'
export const RNCommon = '/common'
export const RNLogout = '/logout'
export const RNNotFound = '/404'
export const RNCarrierSelect = '/select'
export const RNSuccess = '/success'

// Update system
export const RNUpdates = '/updates'
export const RNUpdatesDashboard = '/updates/dashboard'
export const RNUpdatesMachines = '/updates/machines'
export const RNUpdatesVersions = '/updates/versions'
export const RNUpdatesDeploy = '/updates/deploy'
export const RNUpdatesCarrierTypes = '/updates/carrier-types'

// Inventory
export const RNInventory = '/inventory'
export const RNInventoryEquipment = '/inventory/equipment'
export const RNInventoryInstallations = '/inventory/installations'
export const RNInventoryInspections = '/inventory/inspections'
